import { formatEuroPrice } from '@racemap/utilities/functions/billing/formatEuroPrice';
import type { Price } from 'src/components/CostCalculator/getProductPriceFactory';

export function formatPrice(price?: Price, units?: number): string {
  if (price == null) return '-';
  return `${formatEuroPrice(price.amount * (units ?? 1))} excl. VAT`;
}
